import requestSC from "@/utils/requestSC";

export default {
  data() {
    return {
      pdfUrl: "",
    };
  },
  async created() {
    const body = document.querySelector("body");
    body.classList.add("seller-style");

    const loading = this.$loading({
      lock: true,
      text: "加载中...",
    });

    const { busId } = this.$route.query;
    const { msg, code, data } = await requestSC.post(`rest/contract/previewAgreement/v2`, {
      busId,
      isSeller: true,
      invoiceContractType: "payCheck",
    });
    loading.close();

    if (code == "0") {
      this.pdfUrl = data[0].contractUrl;
    } else {
      this.$message.error(msg);
    }
  },

  methods: {
    async confirm() {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
      });
      const { busId } = this.$route.query;
      const { msg, code } = await requestSC.post(`rest/contract/signAgreement`, {
        invoiceContractType: "payCheck",
        busId,
        isSeller: true,
      });
      loading.close();
      if (code == "0") {
        this.$router.back();
      } else {
        this.$message.error(msg);
      }
    },
  },
};
